import type { AuthProviderProps } from 'react-oidc-context'

const issuer = process.env.REACT_APP_OAUTH_ISSUER

export const oidcConfig: AuthProviderProps = {
  authority: issuer,
  metadataUrl: `${issuer}/.well-known/oauth-authorization-server`,
  client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
  scope: process.env.REACT_APP_OAUTH_SCOPE,
  loadUserInfo: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, '/')
  },
}
